import Swiper from 'swiper/bundle';

const rsCarousel = {
    init: (carousels) => {
        const windowWidth = jQuery(window).width();
        carousels.forEach(carousel => {
            const carouselID = '#' + carousel.getAttribute('id');
            const swiperOptions = {};
            const loop = carousel.dataset.loop;
            const autoplay = carousel.dataset.autoplay;
            const effect = carousel.dataset.effect;
            const navigation = carousel.dataset.navigation;
            const pagination = carousel.dataset.pagination;
            const upperPagiContainer = carousel.querySelector('.rs-tabs-carousel__upper-pagination');
            const lowerPagiContainer = carousel.querySelector('.rs-tabs-carousel__lower-pagination');

            swiperOptions.effect = 'slide';
            swiperOptions.slidesPerView = 1;
            swiperOptions.touchEventsTarget = 'wrapper';

            if (windowWidth >= 1024) {
                swiperOptions.allowTouchMove = false;
            }

            if (loop) {
                swiperOptions.loop = true;
            }

            if (autoplay) {
                swiperOptions.autoplay = {
                    delay: autoplay,
                    disableOnInteraction: false,
                    pauseOnMouseEnter: true,
                };
            }

            if (pagination) {
                const pagiNames = [];
                jQuery(carouselID + ' .swiper-wrapper .swiper-slide').each(function(i) {
                    pagiNames.push(jQuery(this).data('name'));
                });
                swiperOptions.pagination = {
                    el: `${carouselID} .rs-tabs-carousel__upper-pagination`,
                    clickable: true,
                    type: 'bullets',
                    bulletActiveClass: 'block-tab__header-item--active',
                    renderBullet: function(index, className) {
                        return `<div class="block-tab__header-item block-tab__header-item-${index} ${className}"><span class="block-tab__header-item__text">${pagiNames[index]}</span></div>`;
                    },
                };
            }

            if (navigation) {
                const slideNext = '.rs-tabs-carousel__nav__next';
                const slidePrev = '.rs-tabs-carousel__nav__prev';
                swiperOptions.navigation = {
                    nextEl: slideNext,
                    prevEl: slidePrev,
                };
            }

            if (effect) {
                swiperOptions.effect = 'fade';
            }

            swiperOptions.autoHeight = true;

            const swiper = new Swiper(`#${carousel.getAttribute('id')}`, swiperOptions);

            // Duplicate the upper pagination markup into the lower pagination container.
            // See: https://gitlab.com/rs-dev/vecna-robotics/-/merge_requests/266
            if (pagination) {
                lowerPagiContainer.innerHTML = upperPagiContainer.innerHTML;
                const pagiItems = upperPagiContainer.querySelectorAll('.block-tab__header-item');
                const observer = new MutationObserver(mutationsList => {
                    for (const mutation of mutationsList) {
                        const el = lowerPagiContainer.querySelector(`.${mutation.target.classList[1]}`);
                        el.classList = mutation.target.classList;
                        el.ariaCurrent = mutation.target.ariaCurrent;
                    }
                });
                pagiItems.forEach(item => {
                    observer.observe(item, { attributes: true });
                });
            }

            if (jQuery(window).width() < 768) {
                swiper.autoplay.stop();
            }
        });
    },
};

export default rsCarousel;
